import type { ActivePolicyState, CheckPolicyByVINRequest, Policy } from '../model/Policy.types';
import { BaseService, defineApi } from '@/shared/api';

class PolicyService extends BaseService {
  async getPolicy(): Promise<Policy> {
    return await this.get('/policy');
  }

  async getCorePolicy(policyId: string | null, token?: string): Promise<Blob> {
    if (!policyId) {
      throw new Error('Missing required parameter: policyId');
    }
    const headers: Record<string, string> = {};

    if (token) {
      headers['Recaptcha-Response-Token'] = token;
    }

    return await this.get<Blob>(`/policy?policyId=${policyId}`, { headers, responseType: 'blob' });
  }

  async checkPolicyByVin(payload: CheckPolicyByVINRequest): Promise<ActivePolicyState> {
    return await this.post('/check-policy-by-vin', payload);
  }
}

export const usePolicyServiceV3 = defineApi(PolicyService, { version: 'v3' });
